const isSwissMarket = () => window.currentMarket === 'ch';

function updateRewardsTextForSwitzerland() {
	if (!isSwissMarket()) return;

	document.querySelectorAll('.upcart-public-rewards__message p').forEach((el) => {
		const updated = el.innerHTML.replace(/in DE\s*(?:&amp;|&)\s*AT/g, 'in CH');
		if (updated !== el.innerHTML) {
			el.innerHTML = updated;
		}
	});
}

function updateRewardsThresholdForSwitzerland() {
	if (!isSwissMarket()) return;

	const settings = window.upcartSettings?.upcartEditorSettings;
	if (!settings) return;

	settings.rewardsMinAmount = '100,00';
	settings.rewardsTiers.tiers[0].minAmount = 100;
}

window.updateUpcartEvent = function () {
	//remove after relaunch? is used in upcart, but was abtesting and not needed anymore?
};
window.localizeTaxesAndShippingClaimText = function () {
	const checkoutNoticeElement = document.querySelector('[upcart-checkout-notice]');
	if (checkoutNoticeElement && window.themeVariables.strings?.taxesAndShippingClaimText) {
		checkoutNoticeElement.innerHTML = window.themeVariables.strings?.taxesAndShippingClaimText;
	}
};
window.localizeWarrantyClaimUpcart = function () {
	const warrantyElement = document.querySelector('[trust-warranty-wording]');
	if (warrantyElement && window.themeVariables.strings?.warrantyClaimText) {
		warrantyElement.innerHTML = window.themeVariables.strings?.warrantyClaimText;
	}
};
window.initFreeShippingClaim = function () {
	//function to generate free shipping claim in cart drawer based on market data
	// called in Upcart Custom HTML!!!
	const container = document.querySelector('.trust-symbole.upcart');
	if (!container) return;
	const freeShippingThreshold = window.themeVariables.strings?.freeShippingThreshold;
	const freeShippingText = window.themeVariables.strings?.freeShippingClaimText;
	if (!freeShippingText || !freeShippingThreshold) return;
	if (container.querySelector('.trust.free-shipping')) return;

	const trust = document.createElement('div');
	trust.classList.add('trust', 'free-shipping');

	const img = document.createElement('img');
	img.src = 'https://cdn.shopify.com/s/files/1/0047/9444/9994/files/delivered.svg?v=1720545594';
	img.loading = 'lazy';
	img.classList.add('trust-icon');

	const span = document.createElement('span');
	const inner = document.createElement('span');
	inner.innerHTML = freeShippingText;

	span.appendChild(inner);
	trust.appendChild(img);
	trust.appendChild(span);
	container.insertBefore(trust, container.firstChild);
};

function observeRewardsMessage() {
	console.log('Observing rewards message for Switzerland...');
	if (!isSwissMarket()) return;
	const messageContainer = document.querySelector('.upcart-public-rewards__message')?.parentElement;
	if (!messageContainer) return;

	const observer = new MutationObserver(() => {
		updateRewardsTextForSwitzerland();
	});

	observer.observe(messageContainer, {
		childList: true,
		subtree: true,
	});

	//updateRewardsTextForSwitzerland();
}

document.addEventListener('DOMContentLoaded', () => {
	updateRewardsThresholdForSwitzerland();
	window.upcartSubscribeCartLoaded(() => {
		updateRewardsTextForSwitzerland();
		observeRewardsMessage();
	});
});
